exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ColorPicker-container {\r\n\tposition: relative;\n}\n.open-DColorPicker {\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tborder-radius: 100%;\r\n\tcursor: pointer;\n}\n.vc-chrome{\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttop: 55px;\r\n\tz-index: 9\n}\r\n", ""]);

// exports
